var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.maintenance && _vm.formData.maintenance.backupType)?_c('row-data',{attrs:{"title":_vm.maintenance.description,"data":_vm.backupName,"file":_vm.formData.maintenance.photo}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }